import { supabase } from './supabase';
import { sendTransactionalEmail } from './email';

// Records an in-app notification for a user and, if we have (or can look up)
// their email address, sends a matching transactional email via SendGrid.
export async function notifyUser({ userId, type, title, body, relatedBidId, relatedPropertyId, email }) {
  if (!userId) return;

  await supabase.from('notifications').insert({
    user_id: userId,
    type,
    title,
    body,
    related_bid_id: relatedBidId || null,
    related_property_id: relatedPropertyId || null,
  });

  let recipientEmail = email;
  if (!recipientEmail) {
    const { data } = await supabase
      .from('profiles')
      .select('email')
      .eq('id', userId)
      .single();
    recipientEmail = data?.email;
  }

  if (recipientEmail) {
    await sendTransactionalEmail({ to: recipientEmail, subject: title, text: body });
  }
}
